var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ua__markdown"},[_c('div',{staticClass:"textBox"},[_c('span',{attrs:{"space":"nbsp"},domProps:{"innerHTML":_vm._s(_vm.parseNodes(_vm.source))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }